<div class="wrapper">
  <div class="field" [hidden]="!searchActive">
    <input class="search-input" type="text" #input [value]="search" [formControl]="inputController" spellcheck="false">
    <mat-icon class="icon" (mousedown)="clear()">close</mat-icon>
  </div>
  <div>&nbsp;</div>
  <mat-icon class="icon" (mousedown)="toggle()">search</mat-icon>
</div>